function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Center, Container, Flex, Link as ChakraLink, Box } from '@chakra-ui/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useNavigate } from 'react-router';
import { ExternalUrls, LandingPageAnchorIds, LandingPageAnchorLinks, WebRoutes } from '@/utils/constants';
import LogoText from '../LogoText';
export default function LandingNavBar(props) {
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsx(Center, _object_spread_props(_object_spread({
        borderBottomWidth: 1,
        borderColor: "borderTertiary",
        position: "sticky",
        top: 0,
        zIndex: 1
    }, props), {
        children: /*#__PURE__*/ _jsxs(Container, {
            as: Flex,
            justifyContent: "space-between",
            maxW: "container.xl",
            alignItems: "center",
            py: 4,
            children: [
                /*#__PURE__*/ _jsx(Box, {
                    flex: 1,
                    children: /*#__PURE__*/ _jsx(LogoText, {})
                }),
                /*#__PURE__*/ _jsxs(Flex, {
                    gap: 8,
                    flex: 1,
                    justifyContent: "center",
                    display: {
                        base: 'none',
                        md: 'flex'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            as: Link,
                            to: LandingPageAnchorLinks[LandingPageAnchorIds.FEATURES],
                            size: "sm",
                            variant: "link",
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "ZXp0z1",
                                defaultMessage: "Features"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            as: ChakraLink,
                            size: "sm",
                            variant: "link",
                            href: ExternalUrls.COMMUNITY_FORUM,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "HqRNN8",
                                defaultMessage: "Support"
                            })
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            as: ChakraLink,
                            size: "sm",
                            variant: "link",
                            href: ExternalUrls.NIGHTDEV,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "p98kOH",
                                defaultMessage: "Our Products"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Flex, {
                    flex: 1,
                    justifyContent: "right",
                    children: /*#__PURE__*/ _jsx(Button, {
                        size: "sm",
                        variant: "cta",
                        onClick: function() {
                            return navigate(WebRoutes.DASHBOARD);
                        },
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "OtVW5B",
                            defaultMessage: "Add to Chat"
                        })
                    })
                })
            ]
        })
    }));
}
